// extracted by mini-css-extract-plugin
export default {"back":"Back_back__rCTOu","title":"Back_title__fkvcY"};